import { render } from "./OpenSource.vue?vue&type=template&id=6dc5781e&ts=true"
import script from "./OpenSource.vue?vue&type=script&lang=ts"
export * from "./OpenSource.vue?vue&type=script&lang=ts"

import "./OpenSource.vue?vue&type=style&index=0&id=6dc5781e&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__